export enum ReportJobStatus {
  PENDING = "PENDING",
  GENERATING = "GENERATING",
  PENDING_REVIEW = "PENDING REVIEW",
  AWAITING_INPUT = "AWAITING INPUT",
  FAILED = "FAILED",
  STARTED = "STARTED",
  EXTRACTING = "EXTRACTING",
}
